import { Model } from "pinia-orm";
import { Domain, Question, CompetenceDomain } from "@/models";

export default class Competence extends Model {
  static entity = "competences";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.string(""),
      code: this.string(""),
      isArchived: this.boolean(false),
      description: this.string(""),
      isDisplayed: this.boolean(true),
      domains: this.attr([]),
      domainsData: this.belongsToMany(Domain, CompetenceDomain, "competenceUuid", "domainUuid"),
      questions: this.hasMany(Question, "competence"),
    };
  }
}
